
















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Branch } from '@/api/model/branch'
import { DashboardView, OrderStatus, ReferralFilterDirection, ReferralView, Role } from '@/api/types'
import { OrderCountAPI } from '@/api/backend-client'
import { EventBus } from './EventBus'
import { OrderCount } from '@/api/model/order-count'
const referrals = namespace('referrals')
const orders = namespace('orders')

@Component
export default class SubNavigationOrderTabs extends Vue {
    @orders.Action applyStatusFilter: ({ statusFilter }) => Promise<void>
    @orders.Action applyAssignedToBranchFilter: ({ assignedToBranchFilter: [] }) => Promise<void>
    @orders.Action applyReferredByBranchFilter: ({ referredByBranchFilter: [] }) => Promise<void>
    @orders.Action applyAssignedToFilter: ({ assignedToFilter: [] }) => Promise<void>
    @orders.Action applyReferredByFilter: ({ referredByFilter: [] }) => Promise<void>
    @orders.Action applyView: ({ view: string, direction, update: boolean }) => Promise<void>
    @orders.Action resetFilters: () => Promise<void>
    @orders.Action applyFilters: (OrdersStateFilters) => Promise<void>
    @orders.Action snapshot: () => Promise<void>

    // @orders.State readonly view!: string
    @orders.State readonly direction!: string
    // @orders.State readonly typeFilter!: OrderType[]
    // @orders.State readonly assignedToFilter!: User
    // @orders.State readonly assignedToBranchFilter!: Branch

    ownerSwitch = true
    filterSwitch = true
    count: OrderCount = null

    async mounted() {
        this.setOwnerDefault()
        await this.updateCount()
    }

    @Watch('ownerSwitch')
    @Watch('filterSwitch')
    async updateCount() {
        this.count = await OrderCountAPI.getOrderCount(this.ownerSwitch, this.filterSwitch)
    }

    setOwner(value: boolean): void {
        this.ownerSwitch = value
    }

    setFilter(value: boolean): void {
        this.filterSwitch = value
    }

    get selectedView(): ReferralView {
        return this.ownerSwitch ? 'user' : 'branches'
    }

    async navigateStatus(status: string): Promise<void> {
        await this.reroute({
            view: this.selectedView,
            direction: this.selectedDirection,
            statusFilter: status,
        })
    }

    async reroute(filters: any): Promise<void> {
        await this.applyFilters(filters)
        await this.snapshot()

        if (this.$route.name !== 'orders_all') {
            await this.$router.push({name: 'orders_all'})
        }

        EventBus.$emit('close')
    }

    get teams(): Branch[] {
        return this.$currentUser.getAvailableBranches()
    }

    get createdFilterLabel(): string {
        return this.ownerSwitch ? this.$t('navigation.order_menu.my_created').toString() : this.$t('navigation.order_menu.team_created').toString()
    }

    get assignedFilterLabel(): string {
        return this.ownerSwitch ? this.$t('navigation.order_menu.my_referred').toString() : this.$t('navigation.order_menu.team_referred').toString()
    }

    get selectedDirection(): ReferralFilterDirection {
        return this.filterSwitch ? 'in' : 'out'
    }

    get notEmployeeRole(): boolean {
        return this.$currentUser.role !== Role.EMPLOYEE
    }

    colorForStatus(status: string): object {
        const colors = {
            [OrderStatus.PENDING]: `rgba(247, 131, 35, 1)`,
            [OrderStatus.SUCCESSFUL]: `rgba(19, 210, 197, 1)`,
            [OrderStatus.UNSUCCESSFUL]: `rgba(235, 89, 140, 1)`,
        }

        return {color: colors[status]}
    }

    setOwnerDefault() {
        if (this.$currentUser.role !== Role.EMPLOYEE) {
            this.ownerSwitch = this.$currentUser.defaultDashboardView === DashboardView.USER
        }
    }
}

